var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShieldIcon = function SvgShieldIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M6.969 1.943v14.528c4.03-1.24 6.046-4.746 6.046-10.52V4.293c-2.138 0-4.153-.783-6.046-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6.969 1.943c-1.854 1.567-3.842 2.35-5.963 2.35v1.658c-.126 5.395 1.861 8.901 5.963 10.52 4.03-1.24 6.046-4.746 6.046-10.52V4.293c-2.138 0-4.153-.783-6.046-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m4.826 8.916 1.69 1.73 2.982-3.221"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShieldIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ShieldIcon.0936bbb20cb743176447da1116b6f954.svg";